import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/credit-suisse-cop-hackathon-sept16/credit-suisse-cop-hackathon-sept16/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
This Hackathon is all about Employee Experience. 
The best contributions will be considered for implementation afterwards.
    </PageDescription>
    <h2>{`Employee Experience`}</h2>
    <p>{`There are three themes for this event around the Credit Suisse `}<strong parentName="p">{`Employee Experience`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul">{`Experience improvement for Employees (e.g. think parking optimization etc.)`}</li>
      <li parentName="ul">{`Developer Experience (e.g. how to accelerate development process, Jenkins CI/CD etc..)`}</li>
      <li parentName="ul">{`Business PoV Experience (e.g. Fintech)`}</li>
    </ul>
    <p>{`If you want to build your prototype on Microsoft Azure (or just learn about the platform), you’ll find a few great resources here.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      